import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {CoinModel} from "../../../_models/coin";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {strictEqual} from "assert";
import {CoinCandlestickConditionService} from "../../../_services/coin-candlestick-condition.service";

@Component({
    selector: 'app-popup-coin-candlestick-condition',
    templateUrl: './popup-coin-candlestick-condition.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class PopupCoinCandlestickConditionComponent extends DialogComponent<CoinModel, boolean> implements OnInit {

    loading = false;
    objModel: any = {};
    objModelOld: any = {};
    currentConditionOneBuy: any = 86400;
    currentConditionOneSell: any = 43200;
    currentConditionTwoBuy: any = 1800;
    currentConditionTwoSell: any = 1800;
    marketID: number;
    coinConditionID: number;
    titlePopup: any;
    configCoinConditionsOne: any = {};
    configCoinConditionsTwo: any = {};
    coinCondition_1: any = [];
    coinCondition_2: any = [];

    msgErrorConditionOneBuy: any;
    msgErrorConditionOneSell: any;
    isValidateCondition: any = false;
    msgErrorConditions: any = '';

    constructor(dialogService: DialogService, private coinCondition: CoinCandlestickConditionService) {
        super(dialogService);
    }

    ngOnInit() {
        // model Data request edit condition
        this.objModel.currentConditionOneBuy = this.currentConditionOneBuy;
        this.objModel.currentConditionOneSell = this.currentConditionOneSell;
        this.objModel.currentConditionTwoBuy = this.currentConditionTwoBuy;
        this.objModel.currentConditionTwoSell = this.currentConditionTwoSell;
        this.objModel.coinConditionID = this.coinConditionID;
        this.objModel.marketID = this.marketID;

        this.coinCondition_1 = this.configCoinConditionsOne;
        this.coinCondition_2 = this.configCoinConditionsTwo;

        this.objModelOld = $.extend(true, {}, this.objModel);
        this.checkValidate();
    }

    editCoinCandlesCondition() {
        let self = this;
        self.coinCondition.editCondition(self.objModel).subscribe(res => {
            if (res.error) {
                self.isValidateCondition = false;
                self.msgErrorConditions = res.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            self.isValidateCondition = false;
            if (error.hasOwnProperty('statusText')) {
                self.msgErrorConditions = error.statusText;
            }
        });
    }

    checkBothBuySell(event: any) {
        let valConditionOne = event.target.options[event.target.selectedIndex].getAttribute('data-val');
        if (valConditionOne <= 0) {
            this.objModel.currentConditionOneBuy = "0";
            this.objModel.currentConditionOneSell = "0";
        }

        this.checkValidate();
    }

    checkValidate() {
        this.isValidateCondition = !this.checkObjectEqual(this.objModelOld, this.objModel);

        if (((this.objModel.currentConditionOneBuy * this.objModel.currentConditionOneSell) > 0
            || (this.objModel.currentConditionOneBuy == 0 && this.objModel.currentConditionOneSell == 0))) {

            this.msgErrorConditionOneBuy = null;
            this.msgErrorConditionOneSell = null;
        } else {
            this.isValidateCondition = false;
            if (this.objModel.currentConditionOneBuy <= 0) {
                this.msgErrorConditionOneBuy = '1つ買いの条件にはcandlestickがまだ設定されない。';
            }
            if (this.objModel.currentConditionOneSell <= 0) {
                this.msgErrorConditionOneSell = '1つ売りの条件にはcandlestickがまだ設定されない。';
            }
        }

        this.checkConditionNotExits();
    }

    checkConditionNotExits() {
        let self = this;
        let objConditionOneBuy = this.coinCondition_1.find(function (obj) {
            return obj.value == self.objModel.currentConditionOneBuy;
        });
        let objConditionOneSell = this.coinCondition_1.find(function (obj) {
            return obj.value == self.objModel.currentConditionOneSell;
        });
        let objConditionTwoBuy = this.coinCondition_2.find(function (obj) {
            return obj.value == self.objModel.currentConditionTwoBuy;
        });
        let objConditionTwoSell = this.coinCondition_2.find(function (obj) {
            return obj.value == self.objModel.currentConditionTwoSell;
        });

        if (objConditionOneBuy == undefined || objConditionOneSell == undefined
            || objConditionTwoBuy == undefined || objConditionTwoSell == undefined) {
            self.isValidateCondition = false;
        }
    }

    checkObjectEqual(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coin-candlestick-condition/popup-coin-candlestick-condition/popup-coin-candlestick-condition.component.ts